import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paremployee-routes',
  templateUrl: './paremployee-routes.component.html',
  styleUrls: ['./paremployee-routes.component.css']
})
export class ParemployeeRoutesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/paremployee-routes/paremployee-routes.component.ts